module.exports = __webpack_public_path__ + "static/media/CSV.30ed84a1.svg";